import {
  enableProdMode,
  importProvidersFrom,
  isDevMode,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from "@angular/core";
import { IonicStorageModule, Storage } from "@ionic/storage-angular";
import { register } from "swiper/element/bundle";
import { defineCustomElements as pwaElements } from "@ionic/pwa-elements/loader";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from "@ionic/angular/standalone";
import {
  RouteReuseStrategy,
  provideRouter,
  withComponentInputBinding,
  withHashLocation,
} from "@angular/router";
import { provideHttpClient } from "@angular/common/http";
import { provideServiceWorker } from "@angular/service-worker";
import { AppComponent } from "./app/app.component";
import { routes } from "./app/app.routes";
import { environment } from "./environments/environment";
import { LogService } from "./app/services/log.service";
import { AppInstanceService } from "./app/services/app.instance.service";

if (environment.production) {
  enableProdMode();
}

export const initStorage = (storage: Storage) => {
  return async () => {
    await storage.create();
  };
};

export const initLogs = (logService: LogService) => {
  return async () => {
    await logService.init();
  };
};

export const initInstanceService = (appInstanceService: AppInstanceService) => {
  return () => appInstanceService.preventMultipleAppInstances();
};

window.addEventListener("DOMContentLoaded", async () => {
  await bootstrapApplication(AppComponent, {
    providers: [
      provideZonelessChangeDetection(),
      provideAppInitializer(() => {
        const initializerFn = initStorage(inject(Storage));
        return initializerFn();
      }),
      provideAppInitializer(() => {
        const initializerFn = initLogs(inject(LogService));
        return initializerFn();
      }),
      provideAppInitializer(() => {
        const initializerFn = initInstanceService(inject(AppInstanceService));
        return initializerFn();
      }),
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      importProvidersFrom(IonicStorageModule.forRoot()),
      provideRouter(routes, withHashLocation(), withComponentInputBinding()),
      provideHttpClient(),
      provideServiceWorker("ngsw-worker.js", {
        enabled: !isDevMode(),
        registrationStrategy: "registerWhenStable:30000",
      }),
      provideIonicAngular({ innerHTMLTemplatesEnabled: true }),
    ],
  }).catch((err) => console.error(err));
  await pwaElements(window);
  register();
});
